import type {RefObject} from 'react';
import {useLayoutEffect, useState, useCallback} from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export const useResizeObserver = (
	ref: RefObject<HTMLElement>,
	callback?: (entry: DOMRectReadOnly) => void,
) => {
	const [width, setWidth] = useState<number>();
	const [height, setHeight] = useState<number>();

	const handleResize = useCallback(
		(entries: ResizeObserverEntry[]) => {
			if (!Array.isArray(entries)) {
				return;
			}

			const entry = entries[0];
			setWidth(entry.contentRect.width);
			setHeight(entry.contentRect.height);

			if (callback) {
				callback(entry.contentRect);
			}
		},
		[callback],
	);

	useLayoutEffect(() => {
		if (!ref.current) {
			return;
		}

		const RO = new ResizeObserver((entries: ResizeObserverEntry[]) =>
			handleResize(entries),
		);
		RO.observe(ref.current);

		return () => {
			RO.disconnect();
		};
	}, [ref, handleResize]);

	return {width, height};
};
